import { graphql } from "@/data-access/graphql";

// ============================================================================
// Broadcast Key Message Fragments
// ============================================================================

export const BroadcastKeyMessageItemFragment = graphql(`
  fragment BroadcastKeyMessageItemFragment on BroadcastKeyMessageItemType
  @_unmask {
    id
    name
    __typename
  }
`);

export const BroadcastKeyMessageGroupFragment = graphql(
  `
    fragment BroadcastKeyMessageGroupFragment on BroadcastKeyMessageGroupType
    @_unmask {
      id
      name
      __typename
      broadcastKeyMessageItems {
        ...BroadcastKeyMessageItemFragment
      }
    }
  `,
  [BroadcastKeyMessageItemFragment],
);

// ============================================================================
// Podcast Key Message Fragments
// ============================================================================

export const PodcastKeyMessageItemFragment = graphql(`
  fragment PodcastKeyMessageItemFragment on PodcastKeyMessageItemType @_unmask {
    id
    name
    __typename
  }
`);

export const PodcastKeyMessageGroupFragment = graphql(
  `
    fragment PodcastKeyMessageGroupFragment on PodcastKeyMessageGroupType
    @_unmask {
      id
      name
      __typename
      podcastKeyMessageItems {
        ...PodcastKeyMessageItemFragment
      }
    }
  `,
  [PodcastKeyMessageItemFragment],
);
